import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, MenuItem, Paper, Select,  TextField } from "@mui/material"

import CheckIcon from '@mui/icons-material/Check';
import dayjs, { Dayjs } from 'dayjs';

import './index'
import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../store";
import { S10CouponsTypesResponse } from "../../../interfaces/s10Employees.interface";
import MyDatepicker from "../../../components/my-datepicker";
import { useLocation } from "react-router-dom";
import { uploadFilesToFilestorage } from "../../../utils/media-files";
import { validateCouponDateRange } from "../../../api/signalApi";
import { getCouponsTypes, requestCouponRange, sendEmailCouponNotification, setCouponsTypesError, setCouponsTypesRangeSelectedIsValid, setCouponsTypesSuccess, setFlowId } from "../../../store/slices/userRequests";
import { addOrUpdateGroupId } from "../../../api/fileStorage";
import { FileStorageS10Data } from "../../../interfaces/fileStorage.interface";
import MySnackbar from "../../../components/MySnackbar";
import ListFilesToUpload from "../../../components/ListFilesToUpload";
import MyDateTimePicker from "../../../components/MyDateTimePicker";
import TableCoupons from "../documents/TableCoupons";
import ThreeComponent from "../../../components/ThreeColumnsComponent";
import MySelectAssignedCompany from "../../../components/MySelectAssignedCompany";


const UseTypePerHours = ({
    startDate,
    setStartDate,
    endDate,
    setEndDate,
}: any) => {

    return (
        <>
            <Grid item xs={12}>
                <MyDateTimePicker
                    labelText="Desde"
                    // defaultValue={dayjs('2022-04-17T15:30')}
                    setSelectedDate={(value) => {
                        setStartDate(value)
                    }}
                    value={startDate}
                />
            </Grid>
            <Grid item xs={12}>
                <MyDateTimePicker
                    labelText="Hasta"
                    minDate={startDate}
                    maxDate={startDate?.endOf('day')}
                    setSelectedDate={(value) => {
                        setEndDate(value)
                    }}
                    value={endDate}
                />
            </Grid>
        </>
    );
}

const UseTypePerDays = ({
    startDate,
    setStartDate,
    endDate,
    setEndDate,
}: any) => {

    return (
        <>
            <Grid item xs={12}>
                <MyDatepicker 
                    labelText="Fecha de inicio"
                    value={startDate}
                    // minDate={dayjs()}
                    setSelectedDate={(value: Dayjs | null) => {
                        setStartDate(value?.endOf('day'));
                        if (endDate) {
                            const dateDaysDiff = dayjs(value).diff(endDate, 'day');
                            if (dateDaysDiff < 0) {
                                setEndDate(null)
                            }
                        }
                        // setEndMaxDate(value?.add(userAvailableDays, 'days'));
                    }}
                    
                />
            </Grid>
            <Grid item xs={12}>
                <MyDatepicker 
                    labelText="Fecha de término"
                    value={endDate}
                    minDate={startDate}
                    // maxDate={endMaxDate}
                    setSelectedDate={(value: Dayjs | null) => setEndDate(value?.endOf('day'))}
                />
            </Grid>
        </>
    );
}

const RequestCouponComponent = ({setCouponTypeSelected: setCouponTypeSelectedProp}: any) => {

    // const theme = useTheme();
    const dispatch = useDispatch<AppDispatch>();
    const {companyselected} = useSelector((state: RootState) => state.auth);
    const {requestCoupon} = useSelector((state: RootState) => state.userRequests);
    const {assignedCompanies} = useSelector((state: RootState) => state.userRequests);
    
    const [comment, setComment] = useState<string>("");
    const [couponTypeSelected, setCouponTypeSelected] = useState<any>("");
    const [startDate, setStartDate] = useState<Dayjs | null>(dayjs().startOf('day'));
    const [endDate, setEndDate] = useState<Dayjs | null>(null);
    const [selectedFiles, setSelectedFiles] = useState<File[]>([]);
    const [couponTypes, setCouponTypes] = useState<S10CouponsTypesResponse[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [rucSelected, setRucSelected] = useState<string>("");


    useEffect( () => {
        setCouponTypes(requestCoupon.couponsTypes);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [requestCoupon.couponsTypes])

    const handleSetCouponSelectedInformation = (couponTypeId: string) => {
        const couponSelected = requestCoupon.couponsTypes.find(c => `${c.CouponId}` === couponTypeId)
        setCouponTypeSelected(couponSelected);
        setCouponTypeSelectedProp(couponSelected?.CouponId)
        const success = couponSelected?.CouponType === 0 ? 0 : 1;
        const response = "";
        dispatch(setCouponsTypesRangeSelectedIsValid({success, response}));
    }

    const handlerSetErrorMsg = (msg: string) => {
        dispatch(setCouponsTypesError(msg));
    }

    const handlerValidateRequest = () => {
        if (!couponTypeSelected) return false;
        if (couponTypeSelected.ForcedAttach && selectedFiles.length === 0) return false;
        if (couponTypeSelected.CouponType === 0 && !requestCoupon.rangeSelectedIsValid) {
            return false;
        }
        if (!startDate || !endDate || startDate > endDate) {
            return false;
        }
        return true;
                            
    }

    const handlerRequestCoupon = async () => {
        if(requestCoupon.couponsTypesLoading || !companyselected || !couponTypeSelected) return;
        if (!startDate || !endDate) return
        if (!handlerValidateRequest()) {
            handlerSetErrorMsg("Rango de fechas no válido.");
            return;
        }
        setLoading(true);
        let filestorageData: FileStorageS10Data[] = [];
        let groupId = "";
        if (selectedFiles.length) {
            const result = await uploadFilesToFilestorage(selectedFiles, handlerSetErrorMsg, false);
            if (!result) {
                setLoading(false);
                return;
            }
            filestorageData = result.filestorageData;
            groupId = result.groupId;
            const updateGroupId = await addOrUpdateGroupId(filestorageData);
            if (updateGroupId?.Type !== 0) {
                handlerSetErrorMsg(updateGroupId?.Message || "Error registrando la información en s10.");
                setLoading(false);
                return;
            }
        }
        const companyData = assignedCompanies.find(c => c.RUCEmpresa === rucSelected);
        dispatch(requestCouponRange(
            couponTypeSelected,
            startDate?.format('YYYY-MM-DDTHH:mm:ss'),
            endDate?.format('YYYY-MM-DDTHH:mm:ss'),
            comment,
            groupId,
            filestorageData.length,
            companyData?.RUCEmpresa,
            companyData?.DescripcionEmpresa    
        ));
        setLoading(false);
    }

    useEffect( () => {
        if (!companyselected?.Code || !startDate || !endDate) {
            return;
        }
        if (endDate <= startDate) {
            handlerSetErrorMsg("Rango de fechas no válido.");
            return;
        }
        if (couponTypeSelected?.CouponType !== 0) {
            return;
        }
        
        validateCouponDateRange(startDate.toDate(), endDate.toDate());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [endDate]);

    return (
        <>
        <Paper
            elevation={3}
            style={{
                width: "100%", 
                borderRadius: "0.5rem",
                minHeight: "10rem",
                padding: "1.5rem",
                marginTop: "0.9rem",
            }}
        >
            <Grid container direction="row">
                <Grid item xs={12}>
                    <MySelectAssignedCompany
                        setRucSelected={(value) => {
                            setRucSelected(value);
                        }} 
                        rucSelected={rucSelected}
                        minWidth='100%'
                    />
                </Grid>
                <Grid item xs={12}>
                    <label 
                        style={{
                            color: "#666",
                            fontFamily: "Roboto",
                            fontSize: ".875rem",
                            fontStyle: "normal",
                            fontWeight: "500",
                            lineHeight: "normal",
                        }}
                    >
                        Tipo de ausencia:
                    </label>
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        displayEmpty
                        style={{height: "2.5rem", marginRight: "1.5rem", border: "none"}}
                        value={couponTypeSelected?.CouponId || ""}
                        onChange={(e) => {
                            handleSetCouponSelectedInformation(e?.target?.value as any)
                        }}
                        fullWidth
                    >
                        <MenuItem value="">Seleccionar</MenuItem>
                        {couponTypes?.map(coupon => (
                            <MenuItem key={String(coupon.CouponId)} value={String(coupon.CouponId)}>{coupon.CouponName}</MenuItem>
                        ))}
                        
                        {/* <MenuItem value={20}>Twenty</MenuItem>
                        <MenuItem value={30}>Thirty</MenuItem> */}
                    </Select>
                </Grid>
                {couponTypeSelected?.UseType === 2 && 
                    <UseTypePerHours 
                        startDate={startDate}
                        setStartDate={setStartDate}
                        endDate={endDate}
                        setEndDate={setEndDate}
                    />
                }

                {couponTypeSelected?.UseType === 0 && 
                    <UseTypePerDays
                        startDate={startDate}
                        setStartDate={setStartDate}
                        endDate={endDate}
                        setEndDate={setEndDate}
                    />
                }
            </Grid>
            <Grid container direction="column" style={{marginTop: "1.5rem", width: "100%"}}>
                <Grid item>
                    <label 
                        style={{
                            color: "#666",
                            fontFamily: "Roboto",
                            fontSize: ".875rem",
                            fontStyle: "normal",
                            fontWeight: "500",
                            lineHeight: "normal",
                        }}
                    >
                        Comentario:
                    </label>
                </Grid>
                <Grid item width={"100%"}>
                    <TextField
                        style={{
                            width: "100%",
                            borderRadius: "0.25rem",
                            height: "auto !important",
                        }}
                        onChange={({target}) => setComment(target.value)}
                        // value={comment}
                        fullWidth
                        rows={3}
                        hiddenLabel
                        variant="outlined"
                        multiline={true}
                    />
                </Grid>
                {couponTypeSelected && 
                    <Grid item width={"100%"} marginTop="1rem">
                        <ListFilesToUpload
                            setSelectedFiles={setSelectedFiles} 
                            selectedFiles={selectedFiles}
                            buttonLabel={`Agregar sustento (${couponTypeSelected.ForcedAttach ? "requerido" : "opcional"})`}
                            filesLimit={1}
                        />
                    </Grid>
                }
            </Grid>
            <Grid 
                container 
                direction="row" 
                style={{marginTop: "1.5rem", width: "100%"}}
                justifyContent="space-between"
            >
                <Grid item xs={12} marginTop={"1rem"}>
                    <Button 
                        className="my-button"
                        variant="contained"
                        style={{
                            width: "100%",
                            height: "2.5rem",
                            display: "inline-flex",
                            padding: "0.625rem 1.5rem",
                            justifyContent: "center",
                            alignItems: "center",
                            gap:" 0.5rem",
                            flexShrink: 0,
                            // backgroundColor: theme.s10palette.S10Blueblue600
                        }}
                        disabled={!handlerValidateRequest()}
                        startIcon={<CheckIcon />}
                        onClick={handlerRequestCoupon}
                    >

                        {loading ? "Solicitando..." : "Solicitar"}
                        
                    </Button>
                </Grid>
            </Grid>
        </Paper>
        
        <MySnackbar
            open={requestCoupon.couponsTypesError !== ""}
            msg={requestCoupon.couponsTypesError}
            severity="error"
            onClose={() =>  handlerSetErrorMsg("")}
        />
        </>
    )
}

const RequestAbsence = () => {
    const location = useLocation();
    const dispatch = useDispatch<AppDispatch>();
    const {companyselected} = useSelector((state: RootState) => state.auth);
    const {requestCoupon} = useSelector((state: RootState) => state.userRequests);
    const [loading, setLoading] = useState<boolean>(false);
    const [requestedAt, setRequestedAt] = useState(new Date());
    const [couponTypeSelected, setCouponTypeSelected] = useState<S10CouponsTypesResponse | null>();


    const handleGetCouponsTypes = () => {
        if (requestCoupon.couponsTypesLoading || loading) return;
        setLoading(true);
        if(!companyselected) return;
        dispatch(getCouponsTypes(-1));
    };

    useEffect( () => {
        if (!requestCoupon.couponsTypesLoading || !loading) {
            handleGetCouponsTypes();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname, companyselected])

    useEffect( () => {
        if(!requestCoupon?.useEmployeeCouponResponsablesData?.length) return;
        dispatch(sendEmailCouponNotification());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [requestCoupon.useEmployeeCouponResponsablesData])

    const ComponentOne = useCallback(() => (
        <RequestCouponComponent 
            couponTypeSelected={couponTypeSelected}
            setCouponTypeSelected={setCouponTypeSelected}
        />
    // eslint-disable-next-line react-hooks/exhaustive-deps
    ), [requestedAt]);
    
    const ComponentTwo = useCallback(() => (
        <TableCoupons 
            key={couponTypeSelected?.Code}
            numberOfCards={1} 
            changeViewOptionHidden={true} 
            hiddenBottomPaginator={true} 
            status={'-4'}
            type={"-2"}
            onlyPendings={true}
            hiddenFilter={true}
        />
    // eslint-disable-next-line react-hooks/exhaustive-deps
    ), [couponTypeSelected?.Code]);
    
    const ComponentThree = useCallback(() => (
        <TableCoupons
            key={couponTypeSelected?.Code}
            numberOfCards={1}
            changeViewOptionHidden={true}
            hiddenBottomPaginator={true}
            status={'-3'}
            type={"-2"}
        />
    // eslint-disable-next-line react-hooks/exhaustive-deps
    ), [couponTypeSelected?.Code]);

    
    return (
        <Grid key={location.pathname} container >

            <ThreeComponent
                tabsTitle={["Solicitar", "Pendientes", "Histórico"]}
                useTabsNameAsTitle={true}
                ComponentOne={ComponentOne}
                ComponentTwo={ComponentTwo}
                ComponentThree={ComponentThree}
            />
            <Dialog
                open={requestCoupon.couponsTypesSuccess !== ""}
                aria-labelledby="responsive-dialog-title"
            >
                <DialogTitle 
                    id="responsive-dialog-title" 
                    style={{padding: "0", margin: "2rem 0 1rem 0", textAlign: "center"}} 
                    variant="h5"
                >
                    Solicitud enviada
                </DialogTitle>
                <DialogContent style={{width: "100%", height: "50%", padding: "0 1.5rem", textAlign: "center"}}>
                    La solicitud de asencia fue enviada con éxito.
                </DialogContent>
                <DialogActions>
                    <Grid container>
                    <Grid item margin={"1.5rem 1.5rem 2.5rem 1.5rem"} padding={0} textAlign="center" xs={12}>
                        <Button 
                            variant="contained" 
                            style={{width: "8rem"}}
                            startIcon={<CheckIcon style={{height: "1rem"}} />}
                            // disabled={loading}
                            onClick={() => {
                                dispatch(setCouponsTypesSuccess(""));
                                dispatch(setFlowId());
                                setRequestedAt(new Date());
                            }}
                        >
                            Aceptar
                        </Button>
                    </Grid>
                    </Grid>
                </DialogActions>
            </Dialog>
        </Grid>
    )

}

export default RequestAbsence